import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import { NavLink } from "react-router-dom";
import { CUSTOMERS_URL } from "../urls";

const styles = {
  display: "block",
  height: "38px",
  width: "38px",
  cursor: "pointer",
  padding: "6px",
};

type Props = {
  customerID: string;
  /** use if you need to nav somewhere other than `${CUSTOMERS_URL}/${customerID}` */
  overrideHref?: string;
  forceNewTab?: boolean;
  overrideIconStyles?: React.CSSProperties;
  /** if not provided: block max-w-fit rounded-full text-gray-700 hover:bg-primaryOpacity90 */
  overrideButtonClasses?: string;
} & React.ComponentPropsWithRef<"a">;

/** Person icon, wrapped in NavLink with ref */
export const ButtonViewCustomer = React.forwardRef<HTMLAnchorElement, Props>(
  (props, ref) => {
    const {
      overrideIconStyles,
      overrideButtonClasses,
      customerID,
      overrideHref,
      forceNewTab,
      ...rest
    } = props;

    return (
      <NavLink
        to={overrideHref ?? `${CUSTOMERS_URL}/${customerID}`}
        target={forceNewTab ? "_blank" : undefined}
        ref={ref}
        {...rest}
        className={`${overrideButtonClasses ?? "block max-w-fit rounded-full text-gray-700 hover:bg-primaryOpacity90"}`}
      >
        <PersonIcon
          aria-label="view customer button"
          style={{ ...styles, ...overrideIconStyles }}
        />
      </NavLink>
    );
  },
);
